import React from 'react';
import MentalWellnessComponent from '../components/mentalwellness/mentalwellness';
import '../components/mentalwellness/mentalwellness.css';
import SEO from '../utils/Seo';
import { Helmet } from 'react-helmet';
const MentalWellness = () => {
   const metadata1 = {
  keywords: `mental health awareness, importance of mental health, Mental wellness programs, 
  Online mental health services, Best therapy for anxiety, Mental health counselor online, 
  Free mental health resources, Therapy sessions near me, Anxiety management techniques, 
  Affordable therapy online, Cognitive behavioral therapy, Depression counseling online, 
  How to improve mental wellness, Therapy for stress relief, Book mental health consultation, 
  Mindfulness exercises online, Local therapy services, Mental health for working adults, 
  Private mental health care, Best mental health apps, Therapist reviews in India, 
  Help for burnout symptoms, Mental health counseling, Benefits of mental health counseling, 
  Types of counseling services, Clinical mental health counseling, 
  Individual counseling for anxiety, Group therapy benefits, Family and couples counseling, 
  Career counseling services, What is mental health counseling?, 
  Online counseling vs in-person, How mental health counseling works, 
  Importance of therapy for mental health, Affordable counseling services near me, 
  Cognitive-behavioral therapy benefits, Emotional well-being counseling, 
  Best counseling services in India, Stress and anxiety therapy options, 
  Counseling for mental health issues, Therapy benefits for depression, 
  Group vs individual therapy benefits, online therapy for depression, 
  online therapy for depression and anxiety, virtual therapy for depression, 
  online mental health counseling, mental health treatment online, 
  online psychological counseling, online counseling for depression, 
  anxiety therapist online, mental counseling online, online psychologist counselling, 
  Stress relief therapy, Local SEO`,
  description:`Get access to online mental wellness programs, cognitive behavioral therapy, affordable counseling, anxiety relief, and emotional support from trusted therapists in India.`
};

    return (<>
    <SEO keyword={metadata1.keywords} description={metadata1.description}/>
   

<MentalWellnessComponent/>

    </>
    );
}

export default MentalWellness;